import { apiOmniaInstance } from "../Api/ApiInstance";

export async function ApproveCreditRequest(approvalConfirmationId) {
  return await apiOmniaInstance.post(
    `/api/omnia-credit/external/credit-request/approve/${approvalConfirmationId}`
  );
}
